/**
 * Creates an array of numbers from start to end (exclusive)
 * @param startOrEnd - If only one arg, this is end (start=0). If two args, this is start.
 * @param end - The end value (exclusive)
 * @returns Array of numbers
 */
export function range(startOrEnd: number, end?: number): number[] {
  const start = end === undefined ? 0 : startOrEnd;
  const length = end === undefined ? startOrEnd : end - start;
  return Array.from({ length }, (_, i) => start + i);
}

/**
 * No-operation function
 */
export function noop(): void {}
